export default __webpack_public_path__ + "static/media/@keaguiar.b26f0304.jpg";